import Bind from 'bind.js';

export default class Carousel {
  constructor(options) {
    this.parentElement = options.parentElement;
    this.data = options.data;

    this.createTemplate();
    this.addSlides();
    this.loadSlick();
  }

  createTemplate() {
    let template = `<div class="carousel-slides"></div>`;

    this.parentElement.insertAdjacentHTML("afterbegin", template);
  }

  addSlides() {
   this.carousel = Bind(
     {slides: this.data.get('images').toJS()},
     {
       slides: {
         dom: '.carousel-slides',
         transform: function (slide) {
           let className = (slide.src === "webAssets/images/upload.png") ? "image upload-preview"
                                                                      : "image";

           return `<div class="carousel-slide">
             <div class="caption">
               <div class="caption-text">
               ${slide.caption}
               </div>
             </div>
             <img class="${className}" src="${slide.src}"/>
           </div>`;
         }
       }
     }
   );
  }

  onSlickLoad(options) {
    window.slickLoaded = true;
    if (options && options.onload) options.onload();

    let parentDiv = this.parentElement.childNodes[0];

    let initialSlide = (options && options.initialSlide) ? options.initialSlide : 0;

    $(parentDiv).slick({
      dots: true,
      infinite: true,
      initialSlide: initialSlide,
      slidesToShow: 1,
      autoplay: this.data.getIn(['properties', 'carouselAutoplay', 'value']),
      autoplaySpeed: this.data.getIn(['properties', 'carouselSpeed', 'value']),
      pauseOnHover: false
    });
  }

  isSlickLoaded(url) {
    var scripts = document.getElementsByTagName('script');
    for (var i = scripts.length; i--;) {
      if ($(scripts[i]).attr('src') === url)  {
        if (window.slickLoaded) {
          this.onSlickLoad();
          return true;
        }

        let onload = scripts[i].onload;

        scripts[i].onload = () => {this.onSlickLoad({onload})};

        return true;
      }
    }
    return false;
  }

  loadSlick() {
    let scriptLoaded = this.isSlickLoaded("js/slick.js", this.parentElement);

    if (scriptLoaded) return;

    let slickScript = document.createElement('script');
    slickScript.setAttribute("type","text/javascript");
    slickScript.setAttribute("src", "js/slick.js");

    let slickCSS = document.createElement("link");
    slickCSS.setAttribute("rel", "stylesheet");
    slickCSS.setAttribute("type", "text/css");
    slickCSS.setAttribute("href", "styles/slick.css");

    let slickThemeCSS = document.createElement("link");
    slickThemeCSS.setAttribute("rel", "stylesheet");
    slickThemeCSS.setAttribute("type", "text/css");
    slickThemeCSS.setAttribute("href", "styles/slick-theme.css");

    slickScript.onload = () => {this.onSlickLoad()};

    document.getElementsByTagName("head")[0].appendChild(slickScript);
    document.getElementsByTagName("head")[0].appendChild(slickCSS);
    document.getElementsByTagName("head")[0].appendChild(slickThemeCSS);
  }

  reRender(data) {
    this.data = data;
    let parentDiv = this.parentElement.childNodes[0];
    $(parentDiv).slick('unslick');
    let currentSlide = $(parentDiv).slick('slickCurrentSlide');

    if ((currentSlide + 1) > data.get('images').count()) {
      currentSlide = data.get('images').count() - 1;
    }

    this.carousel.slides = data.get('images').toJS();
    this.onSlickLoad({initialSlide: currentSlide});
    $(parentDiv).slick('slickPause');
  }
}



// WEBPACK FOOTER //
// ./src/renderers/Carousel.js